import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ColDef, IDatasource, IGetRowsParams } from "ag-grid-community";
import { Subscription } from "rxjs";
import { InventoryService } from "src/app/_services/inventory.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { TableHeaderToolTipComponent } from "../table-header-tool-tip/table-header-tool-tip.component";
import { ServerRequest } from "src/app/_models/global.data.model";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { Global } from "src/app/_utilities/global";

@Component({
  selector: "app-custella-bin-combination",
  templateUrl: "./custella-bin-combination.component.html",
  styleUrls: ["./custella-bin-combination.component.scss"],
  standalone: false,
})
export class CustellaBinCombinationComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  @Output() selecetedBinEvent = new EventEmitter();
  @Output() closeView = new EventEmitter();
  @Input() transferType: any;
  @Input() productId: any;
  @Input() userId: any;
  @Input() changeText: any = "No";
  @Input() selectedFromBinId: any = null;
  @Input() parentType: any = null;
  @Input() url: any = null;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[] = [];
  defaultColDef: any;
  frameworkComponents: any;
  gridParams: any;
  startFrom: any;
  product: any;
  pageSize: any = 25;
  parameters: any;
  gridOptions: any;
  overlayNoRowsTemplate!: string;

  binTransferData: any;
  actionData: any;
  totalRecord: any;
  currentRecordNumber: any;
  refresher!: Subscription;
  searchValue: any = "";

  noData: null | boolean = null;
  translate: any;

  private readonly headerIdMap: { [colId: string]: string } = {
    binDisplayName: "Tbl_HeadBinName",
    shortCode: "Tbl_HeadBinShortCode",
  };

  constructor(
    private inventoryService: InventoryService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService
  ) {
    super();
    this.preInit();
  }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private preInit() {
    this.frameworkComponents = {};

    this.gridOptions = {
      cacheBlockSize: 25,
      rowModelType: "infinite",
      sortingOrder: ["desc", "asc"],
      tooltipShowDelay: 100,
      onGridSizeChanged: (params: any) => {
        params.api.sizeColumnsToFit();
      },
      onFirstDataRendered: () => {
        Global.setHeaderIds(this.headerIdMap);
      }
    };

    this.defaultColDef = {
      enableRowGroup: false,
      enablePivot: false,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };
  }

  private init() {
    this.getLanguageData();
  }

  /********************************** Search Data **************************/
  quickSearch() {
    this.onGridReady(this.gridParams);
  }

  /********************************** View Singal Record **************************/
  onGridReady(params: any) {
    if (params != undefined) {
      this.gridParams = params;

      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();

      const dataSource: IDatasource = {
        getRows: (dsParams: IGetRowsParams) => {
          this.getServerSideData(dsParams);
        },
      };

      this.gridApi.sizeColumnsToFit();
      this.gridApi.setGridOption("datasource", dataSource);
    }
  }

  /********************************** Call Customer API to Display data **************************/
  getServerSideData(agGridGetRowsParams: IGetRowsParams) {
    this.gridApi.hideOverlay();
    const serverRequest = this.getRequestParams(agGridGetRowsParams);

    let binParams = {};
    let transferType = "user";

    if (this.transferType == "LOCATION_BIN") {
      transferType = "location";
      binParams = Object.assign(binParams, { transferType: transferType });
    } else if (this.transferType == "USER_BIN") {
      transferType = "user";
      binParams = Object.assign(binParams, { transferType: transferType });
    }

    if (this.productId) {
      binParams = Object.assign(binParams, { productId: this.productId });
    }
    if (this.userId) {
      binParams = Object.assign(binParams, { userId: this.userId });
    }
    if (this.selectedFromBinId) {
      binParams = Object.assign(binParams, {
        selectedFromBinId: this.selectedFromBinId,
      });
    }
    if (this.parentType) {
      binParams = Object.assign(binParams, { parentType: this.parentType });
    }

    this.inventoryService
      .getAllFromBinCombination(
        this.searchValue,
        serverRequest,
        binParams,
        this.url
      )
      .subscribe(
        (data: any) => {
          console.log(data.body);
          this.binTransferData = data.body.data;
          this.totalRecord = data.body.total;

          this.setGridData(
            agGridGetRowsParams,
            this.binTransferData,
            data.body.total,
            data.body.status
          );
        },
        (err) => {
          this.errorUtil.setErrorMessage(err);
        }
      );
  }

  /********************************** Set Data for Grid Table **************************/
  private setGridData(
    agGridGetRowsParams: IGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    console.log(resultItems, "===");

    if (status === "NO_DATA") {
      this.noData = true;
      this.gridApi.showNoRowsOverlay();
    } else {
      this.noData = false;

      if (this.binTransferData.length === 0) {
        this.gridApi.showNoRowsOverlay();
      } else {
        agGridGetRowsParams.successCallback(this.binTransferData, totalCount);
      }
    }
  }

  /********************************** Request Parameter for api **************************/
  getRequestParams(agGridRequest: IGetRowsParams): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: "binDisplayName", sort: "desc" };
      agGridRequest.sortModel.push(this.parameters);
    }

    this.currentRecordNumber = agGridRequest.startRow;
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }

  /********************************** View Singal Record **************************/
  selectLocationBinData(e: any) {
    this.selectLocationBin(e.data);
  }

  selectLocationBin(val: any) {
    this.selecetedBinEvent.emit(val);
  }

  closeBin() {
    this.closeView.emit(false);
  }

  push(obs: any) {
    super.push(obs);
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.overlayNoRowsTemplate =
            "<div class='not-found'><span>" +
            this.translate?.general.messages.noRecordsFound +
            "</span> </div>";

          if (this.transferType == "LOCATION_BIN") {
            this.columnDefs = [
              {
                headerName:
                  this.translate?.setup.modules.inventory.location.fields.name
                    .singular,
                field: "binDisplayName",
                width: 150,
                headerTooltip: "#",
              },
              {
                headerName:
                  this.translate?.setup.modules.inventory.location.fields
                    .shortCode.singular,
                field: "shortCode",
                width: 100,
                headerClass: " hide-action-border",
                headerTooltip: "#",
              },
            ];
          } else {
            this.columnDefs = [
              {
                headerName:
                  this.translate?.setup.modules.inventory.bins.fields.name
                    .singular,
                field: "binDisplayName",
                width: 150,
                headerTooltip: "#",
              },
              // {
              //   headerName: this.translate?.setup.modules.inventory.bins.fields.shortCode.singular,
              //   field: "shortCode",
              //   width: 100,
              //   headerClass: " hide-action-border",
              //   headerTooltip: "#",
              // },
            ];
          }

          if (this.gridApi) {
            this.gridApi.setGridOption("columnDefs", this.columnDefs);
            this.gridApi.refreshHeader();
            setTimeout(() => {
              this.gridApi.sizeColumnsToFit();
              Global.setHeaderIds(this.headerIdMap);
            }, 0);
          }
        }
      })
    );

    console.log("translate", this.translate);
  }
}